/// <amd-module name="VSS/Features/Markdown/Utils/UserContentAnchorHelper" />
import { AnchoredHeaders } from "VSS/Features/Markdown/Plugins/AnchoredHeaders";

export class UserContentAnchorHelper {
    /**
     * Convert user-provided anchor name into DOM-safe anchor name (e.g. foo is converted into user-content-foo)
     * @param name
     */
    public static convertAnchorName(name: string): string {
        return AnchoredHeaders.anchorNamePrefix + name;
    }

    public static scroll(container: HTMLElement, linkElement: HTMLElement): boolean {
        const link = <HTMLLinkElement>linkElement;
        const linkHrefAttr = link.attributes.getNamedItem("href");

        if (linkHrefAttr) {
            let path = linkHrefAttr.value;
            if (path && path.length > 1 && path.substr(0, 1) === "#") {
                path = path.substr(1).toLowerCase();
                // Find element on page with the adjusted ID
                const elementId = UserContentAnchorHelper.convertAnchorName(path);
                const element = document.getElementById(elementId);
                if (element) {
                    // scrollIntoView is supported by all supported browsers
                    element.scrollIntoView();
                    return false;
                }
            }
        }

        return true;
    }

    /**
     * Attach click handling to rendered user-provided anchor links
     * @param container DOM element housing
     */
    public static attach(container: HTMLElement | undefined): void {
        if (!container) {
            return;
        }

        const linksCollection = container.getElementsByTagName("a");
        const links: HTMLAnchorElement[] = [].slice.call(linksCollection, 0); // Convert collection to array
        for (let link of links) {
            const linkHrefAttr = link.attributes.getNamedItem("href");
            if (linkHrefAttr) {
                const href = linkHrefAttr.value;
                if (href.length > 1 && href.substr(0, 1) === "#") {
                    // Wrapping in closure to be able to scroll that links parent (in case same ID is rendered multiple times)
                    link.onclick = function(this: HTMLElement) {
                        return UserContentAnchorHelper.scroll(container, this);
                    };
                }
            }
        }
    }
}
